import { render, staticRenderFns } from "./dynamic.vue?vue&type=template&id=c7c3ec30&scoped=true&"
import script from "./dynamic.vue?vue&type=script&lang=js&"
export * from "./dynamic.vue?vue&type=script&lang=js&"
import style0 from "./dynamic.vue?vue&type=style&index=0&id=c7c3ec30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c3ec30",
  null
  
)

export default component.exports